import { render } from "./GText.vue?vue&type=template&id=f0e0083c&ts=true"
import script from "./GText.vue?vue&type=script&lang=ts"
export * from "./GText.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__